import type { DialogConfig } from '#types/config/components/dialog'
import type { RecursivePartial } from '#types/utils'

export default {
  brandClasses: {
    backButton: 'absolute top-0 mt-4 flex items-center -ml-2'
  },
  guards: {
    registered: { action: 'block' }
  }
} satisfies RecursivePartial<DialogConfig['forgotPassword']>
